import { RootState } from "@/store/store";
import { normalizedCostWidgetSetupDataPayloadSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupDataPayloadSelector";
import { normalizedCostWidgetSetupDataEndpointSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupDataEndpointSelector";

export const normalizedCostWidgetSetupDataSelector = (state: RootState) => {
  const payload = normalizedCostWidgetSetupDataPayloadSelector(state);

  if (!payload) {
    return;
  }

  return normalizedCostWidgetSetupDataEndpointSelector(payload)(state)?.data;
};
